export const SLICE_NAME = 'userGoalsPage';
